module.exports = __webpack_public_path__ + "static/media/starClearVector.62f4e4da.svg";